import { Link } from "react-router-dom";
import Seo from "components/common/Seo";
import CurriculumCta from "./CurriculumCta";
import CurriculumText from "./CurriculumText";
import {
    CURRICULUM_ACTIONS,
    CURRICULUM_HUB,
    CURRICULUM_LOGO,
    CURRICULUM_SPORTS,
} from "./curriculumData";
import "./Curriculum.scss";

/**
 * /promotion/class — 수중 스포츠 종목 선택(허브) 화면.
 * 각 카드는 /promotion/class/:sport 상세 화면으로 연결된다.
 */
function Curriculum() {
    const { seoTitle, seoDescription, eyebrow, headline, lede, note } = CURRICULUM_HUB;

    return (
        <div className="curriculum curriculum--hub">
            <Seo title={seoTitle} description={seoDescription} />

            <div className="curriculum__page">
                <header className="curriculum__header">
                    <img
                        className="curriculum__logo"
                        src={CURRICULUM_LOGO.navy}
                        alt={CURRICULUM_LOGO.alt}
                    />
                    <p className="curriculum__eyebrow">{eyebrow}</p>
                    <h1 className="curriculum__headline">
                        {headline.lead}
                        <br />
                        {headline.rest}
                        <span className="curriculum__headline-accent">
                            {headline.accent}
                        </span>
                    </h1>
                    <p className="curriculum__lede">
                        <CurriculumText>{lede.join("\n")}</CurriculumText>
                    </p>
                </header>

                <div className="curriculum-hub__cards">
                    {CURRICULUM_SPORTS.map((sport) => (
                        <Link
                            key={sport.slug}
                            className={`curriculum-hub__card curriculum-hub__card--${sport.theme}${
                                sport.darkCard ? " curriculum-hub__card--dark" : ""
                            }`}
                            to={`/promotion/class/${sport.slug}`}
                        >
                            <div className="curriculum-hub__shot">
                                <img src={sport.photo} alt="" loading="lazy" />
                                <div className="curriculum-hub__name">
                                    <span className="curriculum-hub__name-en">
                                        {sport.name.en}
                                    </span>
                                    <span className="curriculum-hub__name-ko">
                                        {sport.name.ko}
                                    </span>
                                </div>
                            </div>
                            <div className="curriculum-hub__body">
                                <p className="curriculum-hub__slogan">
                                    {sport.hubCard.slogan}
                                </p>
                                <p className="curriculum-hub__who">
                                    <b>이런 분께</b>
                                    <span>{sport.hubCard.who}</span>
                                </p>
                                <p className="curriculum-hub__desc">
                                    {sport.hubCard.desc}
                                </p>
                                <span className="curriculum-hub__go">
                                    {sport.hubCard.cta}{" "}
                                    <span aria-hidden="true">→</span>
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="curriculum__actions">
                    <CurriculumCta
                        action={{ ...CURRICULUM_ACTIONS.schedule, tone: "schedule" }}
                    />
                    <CurriculumCta
                        action={{ ...CURRICULUM_ACTIONS.kakaoSport, tone: "kakao" }}
                    />
                </div>

                <footer className="curriculum__footer">
                    <p className="curriculum__note">
                        <CurriculumText>{note.join("\n")}</CurriculumText>
                    </p>
                    <img
                        className="curriculum__logo curriculum__logo--footer"
                        src={CURRICULUM_LOGO.white}
                        alt={CURRICULUM_LOGO.alt}
                    />
                </footer>
            </div>
        </div>
    );
}

export default Curriculum;
